import { all } from 'redux-saga/effects'
import {
    watchSignIn,
    watchRegisterGuest,
    watchChoseProject,
} from './auth';
import {
    watchDeletePhotos,
    watchGetPhotos,
    watchGetPhotoFaults
} from './photos';
import {
    watchLoadResourcesDetails,
} from './resource';
import {
    watchGetLayersConfig,
} from './map';
import {
    watchLoadVideosDetails,
    watchLoadVideoTrack,
    watchDeleteVideos,
} from './video';
import {
    watchLoadModelsDetails,
    watchDeleteModels,
} from './model';
import {
    watchGetFlights,
    watchDeleteFlight,
    watchEditFlight,
    watchAddFlight,
    watchStartFlight,
    watchfinishFlight,
    watchGetProducts,
    watchGetTimeZones,
} from './flightManager';
import {
    watchGetFaults,
    watchGetFaultPhotosAndVideos,
    watchGetFaultTagsDictionary,
    watchEditFault,
    watchAddFault,
    watchDeleteFault,
} from './faults';
import {
    watchGetComments,
} from './comments';

const sagas = [
    watchSignIn(),
    watchRegisterGuest(),
    watchChoseProject(),
    watchDeletePhotos(),
    watchGetPhotos(),
    watchGetPhotoFaults(),
    watchLoadResourcesDetails(),
    watchLoadModelsDetails(),
    watchDeleteModels(),
    watchGetLayersConfig(),
    watchGetFlights(),
    watchGetProducts(),
    watchGetTimeZones(),
    watchDeleteFlight(),
    watchEditFlight(),
    watchAddFlight(),
    watchStartFlight(),
    watchfinishFlight(),
    watchLoadVideosDetails(),
    watchLoadVideoTrack(),
    watchDeleteVideos(),
    watchGetFaults(),
    watchGetFaultPhotosAndVideos(),
    watchGetFaultTagsDictionary(),
    watchEditFault(),
    watchAddFault(),
    watchDeleteFault(),
    watchGetComments(),
]

export default function* rootSaga() {
    yield all(sagas);
}


// WEBPACK FOOTER //
// ./src/sagas/RootSaga.jsx